/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { requestScaleValue } from '../fn/measurement/request-scale-value';
import { RequestScaleValue$Params } from '../fn/measurement/request-scale-value';
import { RequestScaleValueResponse } from '../models/request-scale-value-response';

@Injectable({ providedIn: 'root' })
export class MeasurementService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `requestScaleValue()` */
  static readonly RequestScaleValuePath = '/api/v1/Measurement/{workCenterId}/RequestScaleValue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestScaleValue()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestScaleValue$Response(params: RequestScaleValue$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestScaleValueResponse>> {
    return requestScaleValue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `requestScaleValue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  requestScaleValue(params: RequestScaleValue$Params, context?: HttpContext): Observable<RequestScaleValueResponse> {
    return this.requestScaleValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestScaleValueResponse>): RequestScaleValueResponse => r.body)
    );
  }

}
